import { Alert } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Helmet } from 'react-helmet';

import { Book, useBook } from 'api/book/model';
import { Box, Button, CustomBox, GridChild, GridContainer, Title } from 'common';
import { BookCard } from 'widgets/cards';

import { useLanguage } from '../../context/LanguageContext';
import { bookClubSinglePageLabels } from '../../locales/translations'

import { BookImagesCarousel } from './BookImagesCarousel'

export const SingleBookPage = () => {
    const { id } = useParams();
    const { onGetAllBooks, onGetOneBook } = useBook();

    const [bookDetails, setBookDetails] = useState<Book | null>(null);
    const [latestBook, setLatestBook] = useState<Book[]>([]);
    const [loadingDetails, setLoadingDetails] = useState(true);
    const [loadingLatestBook, setLoadingLatestBook] = useState(true);
    const [error, setError] = useState<string>('');

    const { language } = useLanguage();
    const otherMeetings = bookClubSinglePageLabels.otherMeetings[language]
    const allDiscussionsButton = bookClubSinglePageLabels.allDiscussionsButton[language]


    useEffect(() => {
        const fetchBookDetails = async () => {
            try {
                const result = await onGetOneBook(Number(id));
                if (result.success) {
                    setBookDetails(result.data);
                } else {
                    setError('Не удалось загрузить детали новости.');
                }
            } catch (error) {
                setError('Произошла ошибка при запросе деталей новости.');
            } finally {
                setLoadingDetails(false);
            }
        };
        const fetchLatestBook = async () => {
            try {
                const result = await onGetAllBooks();
                if (result.success) {

                    const sortedBook = result.data.sort((a: Book, b: Book) =>
                        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                    );
                    setLatestBook(sortedBook);
                } else {
                    setError('Произошла ошибка при загрузке списка новостей.');
                }
            } catch (error) {
                setError('Произошла ошибка при запросе списка новостей.');
            } finally {
                setLoadingLatestBook(false);
            }
        };
        fetchBookDetails();
        fetchLatestBook();
    }, [id, onGetOneBook, onGetAllBooks]);





    if (loadingDetails && loadingLatestBook)
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress />
            </Box>
        );

    if (error) return <Alert severity="error">{error}</Alert>;

    return (
        <Box>
            <GridContainer>
                <GridChild md={8}>
                    {bookDetails && (
                        <CustomBox title={bookDetails[`title_${language}`]}>
                            <Helmet>
                                <title>{bookDetails[`title_${language}`]}</title>
                                <meta name="description" content={bookDetails[`title_${language}`]} />
                            </Helmet>
                            {bookDetails.images && bookDetails.images.length > 0 && bookDetails.images[0] ? (
                                <BookImagesCarousel bookItem={bookDetails} />
                            ) : (<ImageNotSupportedIcon
                                sx={{
                                    height: 200,
                                    width: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '5rem'
                                }}
                            />)}
                            <Title gutterBottom variant="h5" sx={{ fontWeight: 600, marginTop: 2 }}>
                                {bookDetails[`title_${language}`]}
                            </Title>
                            <Title gutterBottom variant="body2" color="text.secondary">
                                <div dangerouslySetInnerHTML={{
                                    __html: bookDetails[`description_${language}`]
                                }} />
                            </Title>
                            <Title variant="body2" color="text.primary">
                                {dayjs(bookDetails.created_at).format('DD.MM.YYYY')}
                            </Title>
                        </CustomBox>
                    )}
                </GridChild>

                <GridChild md={4}>
                    {!loadingLatestBook && (
                        <CustomBox title={otherMeetings}>
                            {latestBook.slice(0, 3).map((bookItem) => (
                                <BookCard key={bookItem.id} bookItem={bookItem} />
                            ))}

                            <Box sx={{ paddingTop: 6, display: 'flex', justifyContent: 'start' }}>
                                <Button variant="contained" color="error" href="/book-club">
                                    {allDiscussionsButton}
                                </Button>
                            </Box>
                        </CustomBox>
                    )}
                </GridChild>
            </GridContainer>
        </Box>
    );
};
